import React, { useState, useEffect } from 'react';
import './ConfigData.css';
import baseURL from '../../url';
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStore, faUtensils } from '@fortawesome/free-solid-svg-icons';

export default function ConfigData() {
    const [config, setConfig] = useState({
        domicilio_activo: 0,
        retiro_activo: 1,
        mesa_activo: 1,
        reservas_activo: 0,
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        cargarConfiguracion();
    }, []);

    const cargarConfiguracion = async () => {
        try {
            const response = await fetch(`${baseURL}/configGet.php`);
            const data = await response.json();
            if (data.success) {
                setConfig(data.config);
            }
        } catch (error) {
            console.error('Error al cargar configuración:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleToggle = async (campo) => {
        const nuevoValor = config[campo] === 1 ? 0 : 1;
        const nuevaConfig = { ...config, [campo]: nuevoValor };

        try {
            const response = await fetch(`${baseURL}/configUpdate.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(nuevaConfig),
            });

            const data = await response.json();

            if (data.success) {
                setConfig(nuevaConfig);
                Swal.fire({
                    icon: 'success',
                    title: '¡Éxito!',
                    text: 'Configuración actualizada correctamente',
                    timer: 1500,
                    showConfirmButton: false,
                });
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: data.message,
                });
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error al actualizar la configuración',
            });
        }
    };

    if (loading) {
        return <div className='loading'>Cargando configuración...</div>;
    }

    return (
        <div className='ConfigDataContainer'>
            <h2>Configuración del Sistema</h2>
            <p className='subtitle'>Active o desactive las opciones disponibles para sus clientes</p>

            <div className='configSection'>
                <h3>Tipos de Pedido</h3>
                <div className='configGrid'>
                    <div className='configCard'>
                        <div className='configIcon'>
                            <FontAwesomeIcon icon={faStore} />
                        </div>
                        <div className='configInfo'>
                            <h4>Retirar Personalmente</h4>
                            <p>Permite a los clientes retirar pedidos personalmente en el local.</p>
                        </div>
                        <label className='switch'>
                            <input
                                type='checkbox'
                                checked={config.retiro_activo === 1}
                                onChange={() => handleToggle('retiro_activo')}
                            />
                            <span className='slider'></span>
                        </label>
                    </div>
                </div>
            </div>

            <div className='infoBox'>
                <strong>Nota:</strong> Los cambios se reflejarán inmediatamente en el menú digital.
                Los clientes solo verán las opciones que estén activadas.
            </div>
        </div>
    );
}




